<mat-spinner *ngIf="loading" style="margin: 0 auto;"></mat-spinner>
<a *ngIf="!loading" download style="margin: 0 auto;" [href]='fileUrl' mat-button>
    <mat-icon>cloud_download</mat-icon><br>
    Pobierz PDF</a>